'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const Guid=require('pulsar-utils/dist-es6/domain/guid');let

ValidatedFieldDirective=class ValidatedFieldDirective extends BaseControllerBackedDirective{
get restrict(){
return'A';
}

get objectBindings(){
return['form','value','submissionResult','customErrorHandler','isDisabled','disabledClassOnly','isTextArea'];
}

get textBindings(){
return['label','propertyName','placeholder','type','fieldId'];
}

get templateUrl(){
return'/templates/directives/validatedFieldDirective/validatedFieldTemplate';
}

get controller(){
return ValidatedFieldController;
}};let


ValidatedFieldController=class ValidatedFieldController{
static get $inject(){
return['$scope'];
}

constructor($scope){
this._defaultErrorMessage=this._requiredFieldMessage();

this.type=this.type||'text';
this.fieldId=this.fieldId||Guid.create().toString();

this.isDisabled=this.isDisabled||!1;
this.disabledClassOnly=this.disabledClassOnly||!1;
this.isTextArea=this.isTextArea||!1;

this.placeholder=this.placeholder||'';
this.label=this.label||'';

$scope.$watch('controller.submissionResult',result=>this._displaySubmissionErrors(result));

$scope.$watch('controller.value',()=>{
if(!this.fieldIsTouchedAndInvalid){
this._resetErrorMessage();
}
});
}

get fieldIsTouchedAndInvalid(){
if(!_.exists(this.form[this.fieldId])){
return!1;
}

return this.form[this.fieldId].$touched&&this.form[this.fieldId].$invalid;
}

get defaultErrorMessage(){
return this._defaultErrorMessage;
}

get errorMessage(){
return this._errorMessage;
}

_resetErrorMessage(){
this._errorMessage=void 0;
}

_displaySubmissionErrors(submissionResult){
this._resetErrorMessage();

if(_.exists(submissionResult)){
if(_.exists(this.customErrorHandler)){
let customErrorMessage=this.customErrorHandler(submissionResult);

if(_.exists(customErrorMessage)){
this._errorMessage=customErrorMessage;
return;
}
}

if(submissionResult.status==='HttpError'&&submissionResult.body.httpStatus===422){
this._errorMessage=this._findSchemaError(submissionResult.body.errors);
}
}
}

_findSchemaError(errorsArray){
for(let error of errorsArray){
if(error.indexOf(this.propertyName)>-1){
if(/requires property/gi.test(error)){
return this._requiredFieldMessage();
}
if(/does not conform/gi.test(error)){
return this._invalidFieldMessage();
}
}
}

return void 0;
}

_invalidFieldMessage(){
return`Please enter a valid ${this.label.toLowerCase()}.`;
}

_requiredFieldMessage(){
return`${_.upperFirst(this.label)} is a required field.`;
}};


module.exports=ValidatedFieldDirective;
module.exports.controller=ValidatedFieldController;
//# sourceMappingURL=validatedFieldDirective.js.map
